import { IkasBaseModel } from ".";

/**
 * Creates an empty base model object
 * @returns An initialized empty base model object.
 */
export function createIkasBaseModel(): IkasBaseModel {
  return {
    id: "",
    createdAt: Date.now(),
    updatedAt: Date.now(),
    deleted: false,
  };
}
